import {
  useChakra,
  useLatestRef,
  type UseToastOptions as ChakraUseToastOptions,
} from '@chakra-ui/react-v2';
import { useMemo } from 'react';

import {
  createStandaloneToast,
  type CreateStandaloneToastReturn,
} from './createStandaloneToast';

export type UseToastOptions = ChakraUseToastOptions;

export type UseToastReturn = CreateStandaloneToastReturn['toast'];

export const useToast = (options?: UseToastOptions): UseToastReturn => {
  const { theme, setColorMode, toggleColorMode, colorMode } = useChakra();

  const toastOptions = useLatestRef(options);

  return useMemo(() => {
    const { toast } = createStandaloneToast({
      theme,
      colorMode,
      setColorMode,
      toggleColorMode,
      defaultOptions: toastOptions.current,
    });

    return toast;
  }, [theme, setColorMode, toggleColorMode, colorMode, toastOptions]);
};
